<script>
import { Multiselect, disableForm } from 'vue-bootstrap';
import langMixin from '@/lib/components/Translations/mixins/lang-mixin.js';
import tabularMixin from '@/lib/components/Navigation/mixins/tabular-mixin.js';
import AttachmentTypes from '@/lib/components/Attachments/AttachmentTypes';
import VisibilityMatrix from '@/lib/components/Shared/VisibilityMatrix';
import LocalisedDatepicker from '@/lib/components/Shared/LocalisedDatepicker';
import JudgingModes from './JudgingModes';

export default {
  components: {
    Multiselect,
    AttachmentTypes,
    JudgingModes,
    VisibilityMatrix,
    LocalisedDatepicker
  },
  mixins: [langMixin, tabularMixin, disableForm],
  props: {
    scoreSet: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      conditionalCheckbox: {
        comments: 'commentRequired',
        abstention: 'commentOnAbstention',
        commentScores: 'commentScoresRequired',
        duplicateEntryCount: 'duplicateEntryList'
      },
      mode: this.scoreSet.mode,
      comments: this.scoreSet.comments,
      commentRequired: this.scoreSet.commentRequired,
      abstention: this.scoreSet.abstention,
      commentOnAbstention: this.scoreSet.commentOnAbstention,
      commentScores: this.scoreSet.commentScores,
      commentScoresRequired: this.scoreSet.commentScoresRequired,
      duplicateEntryCount: this.scoreSet.duplicateEntryCount,
      duplicateEntryList: this.scoreSet.duplicateEntryList
    };
  },
  methods: {
    selectMode(mode) {
      this.mode = mode;
    },
    conditionalChange(event) {
      const conditionalCheckbox = this.conditionalCheckbox[event.target.name];
      if (conditionalCheckbox && !event.target.checked) {
        this[conditionalCheckbox] = false;
      }
    }
  }
};
</script>
